import { gql } from "@apollo/client";
// ------ ASSIGN TO BRANCH ------ //
export const LOCKER_TYPES = gql`
  {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const GET_PARTNERS_WITH_OR_WITHOUT_ID = gql`
  query ($operatorId: ID!, $partnerId: ID) {
    partners(operatorId: $operatorId, partnerId: $partnerId) {
      partnerId
      companyNickname
    }
  }
`;
export const PARTNER_BRANCH_ASSIGNMENT_BY_UNASSIGNED_LOCKERS = gql`
  query ($operatorId: ID!, $lockerTypeId: ID!, $partnerId: ID!) {
    partnerBranchAssignmentsByUnassignedLockers(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      partnerId: $partnerId
    ) {
      lockerId
      lockerName
      unassignedCount
      doorsOccupied
      unassignedPartnerBranches {
        partnerBranchId
        partnerBranch
      }
    }
  }
`;

export const PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_BRANCHES = gql`
  query ($operatorId: ID!, $partnerId: ID!, $lockerTypeId: ID!) {
    partnerBranchAssignmentsByAssignedBranches(
      operatorId: $operatorId
      partnerId: $partnerId
      lockerTypeId: $lockerTypeId
    ) {
      partnerBranchId
      partnerBranch
      assignedCount
      assignedLockers {
        lockerId
        lockerName
        partnerBranchAssignmentId
      }
    }
  }
`;
export const PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_LOCKERS = gql`
  query ($operatorId: ID!, $partnerId: ID!, $lockerTypeId: ID!) {
    partnerBranchAssignmentsByAssignedLockers(
      operatorId: $operatorId
      partnerId: $partnerId
      lockerTypeId: $lockerTypeId
    ) {
      lockerId
      lockerName
      assignedCount
      assignedBranches {
        partnerBranchId
        partnerBranch
        partnerBranchAssignmentId
      }
    }
  }
`;

export const GET_ALL_LOCKER_NAMES = gql`
  {
    lockers {
      lockerId
      lockerName
    }
  }
`;

export const DELETE_PARTNER_BRANCH_ASSIGNMENT = gql`
  mutation ($operatorId: ID!, $partnerBranchAssignmentId: ID!) {
    deletePartnerBranchAssignment(
      operatorId: $operatorId
      partnerBranchAssignmentId: $partnerBranchAssignmentId
    ) {
      ok
    }
  }
`;

export const ADD_PARTNER_BRANCH_ASSIGNMENT = gql`
  mutation ($operatorId: ID!, $partnerBranchId: ID!, $lockerId: ID!) {
    addPartnerBranchAssignment(
      operatorId: $operatorId
      partnerBranchId: $partnerBranchId
      lockerId: $lockerId
    ) {
      partnerBranchAssignment {
        locker {
          lockerId
          lockerName
        }
      }
    }
  }
`;

// ------ ASSIGN TO AGENTS ------ //
export const PARTNER_AGENT_ASSIGNMENT_BY_LOCKERS = gql`
  query (
    $operatorId: ID!
    $partnerId: ID!
    $lockerTypeId: ID!
    $partnerBranchId: ID!
  ) {
    partnerAgentAssignmentsByLockers(
      operatorId: $operatorId
      partnerId: $partnerId
      lockerTypeId: $lockerTypeId
      partnerBranchId: $partnerBranchId
    ) {
      lockerId
      lockerName
      partnerBranchAssignmentId
      assignedAgents {
        partnerAgentId
        partnerAgentAssignmentId
        agentName
        firstName
        lastName
      }
    }
  }
`;
export const GET_AGENTS_BY_PARTNER_AND_BRANCH = gql`
  query ($operatorId: ID!, $partnerId: ID!, $partnerBranchId: ID!) {
    agentsWithFilter(
      operatorId: $operatorId
      partnerId: $partnerId
      partnerBranchId: $partnerBranchId
    ) {
      agentName
      firstName
      lastName
      partnerAgentId
    }
  }
`;

export const ADD_PARTNER_AGENT_ASSIGNMENT = gql`
  mutation (
    $operatorId: ID!
    $partnerAgentId: ID!
    $partnerBranchAssignmentId: ID!
  ) {
    addPartnerAgentAssignment(
      operatorId: $operatorId
      partnerAgentId: $partnerAgentId
      partnerBranchAssignmentId: $partnerBranchAssignmentId
    ) {
      partnerAgentAssignment {
        partnerAgentAssignmentId
      }
    }
  }
`;

export const DELETE_PARTNER_AGENT_ASSIGNMENT = gql`
  mutation ($operatorId: ID!, $partnerAgentAssignmentId: ID!) {
    deletePartnerAgentAssignment(
      operatorId: $operatorId
      partnerAgentAssignmentId: $partnerAgentAssignmentId
    ) {
      ok
    }
  }
`;

// ------ ASSIGN TO PARTNER ------ //
export const PARTNER_ASSIGNMENT_BY_UNASSIGNED_LOCKERS = gql`
  query ($operatorId: ID!, $lockerTypeId: ID!, $partnerId: ID) {
    partnerAssignmentsByUnassignedLockers(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      partnerId: $partnerId
    ) {
      lockerId
      lockerName
      unassignedPartnerBranches {
        partner
        partnerBranchId
        partnerBranch
      }
    }
  }
`;

// ----------- SEARCH LOCKERS ------------//
export const LOCKER_INFO = gql`
  query ($operatorId: ID!, $lockerTypeId: ID) {
    lockerInfo(operatorId: $operatorId, lockerTypeId: $lockerTypeId) {
      lockerId
      lockerName
      lockerType
      lockerTypeId
      availableDoors
      occupiedDoors
      unavailableDoors
      partners {
        partnerId
        companyNickname
        email
        partnerBranchId
        partnerBranch
        agents
      }
      contacts {
        contactName
        contactPosition
        contactMobile
        contactLandline
        contactEmail
        lockerContactId
        contactPriority
        contactType
      }
    }
  }
`;

export const NEW_LOCKER_INFO_Q = gql`
  query (
    $operatorId: ID!
    $lockerId: ID
    $lockerStateNo: Int
    $lockerStatus: Int
  ) {
    lockerInfo(
      operatorId: $operatorId
      lockerId: $lockerId
      lockerStateNo: $lockerStateNo
      lockerStatus: $lockerStatus
    ) {
      lockerId
      lockerName
      lockerTypeId
      lockerType
      online
      totalDoors
      availableDoors
      occupiedDoors
      unavailableDoors
      operatorId
      lockerStatus
      lockerStateNo
      totalSubcabinets
      partners {
        partnerId
        companyNickname
        email
        partnerBranchId
        partnerBranch
        agents
      }
    }
  }
`;

// ------- Locker Fees ---------- //
export const LOCKER_USER_TYPE = gql`
  query ($operatorId: ID!) {
    lockerUserTypes(operatorId: $operatorId) {
      userTypeId
      userType
      userShipoutFees {
        doorSize {
          doorSize
          doorSizeId
        }
        userShipoutFeeId
        initialReturnFee
        addInitialFreeHours
        excessFeePerInc
        incByHours
        maxOverstayCharge
      }
      userPickupFees {
        doorSize {
          doorSize
          doorSizeId
        }
        userPickupFeeId
        addInitialFreeHours
        initialFee
      }
      __typename
    }
  }
`;
export const LOCKER_FEE_TABLE = gql`
  query ($operatorId: ID!) {
    lockerFeeTable(operatorId: $operatorId) {
      lockerTypeId
      lockerType
      partnerTypes {
        partnerTypeId
        partnerType
      }
      userTypes {
        userTypeId
        userType
      }
    }
  }
`;

export const LOCKER_FEE_TABLE_UNGROUPED = gql`
  query ($operatorId: ID!) {
    lockerFeesByType(operatorId: $operatorId) {
      partnerType
      partnerTypeId
      userType
      userTypeId
      lockerType
      lockerTypeId
      partnerCategory
      partnerCategoryNo
    }
  }
`;

export const USER_PICKUP_FEES = gql`
  query ($operatorId: ID!, $userTypeId: ID!, $lockerTypeId: ID!) {
    userPickupFees(
      operatorId: $operatorId
      userTypeId: $userTypeId
      lockerTypeId: $lockerTypeId
    ) {
      userPickupFeeId
      doorSize {
        doorSizeId
      }
      initialFee
      addInitialFreeHours
      excessFeePerInc
      incByHours
      maxOverstayCharge
    }
  }
`;

export const PARTNER_DROPOFF_FEE = gql`
  query ($operatorId: ID!, $partnerTypeId: ID!, $lockerTypeId: ID!) {
    partnerDropoffFees(
      operatorId: $operatorId
      partnerTypeId: $partnerTypeId
      lockerTypeId: $lockerTypeId
    ) {
      partnerDropoffFeeId
      doorSize {
        doorSizeId
        doorSize
      }
      dropoffFee
      initialFreeHours
      rtsFee
      rtsOverstayRate
      rtsOverstayMaxFee
      rtsOverstayUnitHours
    }
  }
`;
export const PARTNER_SHIPOUT_FEE = gql`
  query ($operatorId: ID!, $partnerTypeId: ID!, $lockerTypeId: ID!) {
    partnerShipoutFees(
      operatorId: $operatorId
      partnerTypeId: $partnerTypeId
      lockerTypeId: $lockerTypeId
    ) {
      partnerShipoutFeeId
      doorSize {
        doorSizeId
      }
      incByHours
      commissionPercent
      initialShipoutFee
      initialFreeHours
      excessFeePerInc
      maxOverstayCharge
    }
  }
`;

export const ADD_USER_PICKUP_FEES = gql`
  mutation (
    $operatorId: ID!
    $lockerTypeId: ID!
    $userTypeId: ID!
    $doorSizeId: ID!
    $initialFee: Float!
    $addInitialFreeHours: Int!
    $excessFeePerInc: Float!
    $incByHours: Int!
    $maxOverstayCharge: Float!
  ) {
    addUserPickupFee(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      userTypeId: $userTypeId
      doorSizeId: $doorSizeId
      initialFee: $initialFee
      addInitialFreeHours: $addInitialFreeHours
      excessFeePerInc: $excessFeePerInc
      incByHours: $incByHours
      maxOverstayCharge: $maxOverstayCharge
    ) {
      userPickupFee {
        userPickupFeeId
      }
    }
  }
`;
export const ADD_USER_SHIPOUT_FEES = gql`
  mutation (
    $operatorId: ID!
    $lockerTypeId: ID!
    $userTypeId: ID!
    $doorSizeId: ID!
    $initialReturnFee: Float!
    $addInitialFreeHours: Int!
    $excessFeePerInc: Float!
    $incByHours: Int!
    $maxOverstayCharge: Float!
  ) {
    addUserShipoutFee(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      userTypeId: $userTypeId
      doorSizeId: $doorSizeId
      initialReturnFee: $initialReturnFee
      addInitialFreeHours: $addInitialFreeHours
      excessFeePerInc: $excessFeePerInc
      incByHours: $incByHours
      maxOverstayCharge: $maxOverstayCharge
    ) {
      userShipoutFee {
        userShipoutFeeId
      }
    }
  }
`;
export const LOCKER_RELATED_PARTNER_TYPE_LIST = gql`
  query ($operatorId: ID!, $partnerTypeId: ID, $lockerTypeIds: [Int]) {
    partnerTypes(
      operatorId: $operatorId
      partnerTypeId: $partnerTypeId
      lockerTypeIds: $lockerTypeIds
    ) {
      partnerType
      partnerTypeId
      __typename
    }
  }
`;

export const ADD_PARTNER_DROPOFF_FEE = gql`
  mutation (
    $operatorId: ID!
    $lockerTypeId: ID!
    $partnerTypeId: ID!
    $doorSizeId: ID!
    $dropoffFee: Float!
    $initialFreeHours: Int!
    $rtsFee: Float!
    $rtsOverstayMaxFee: Float!
    $rtsOverstayRate: Float!
    $rtsOverstayUnitHours: Int!
  ) {
    addPartnerDropoffFee(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      partnerTypeId: $partnerTypeId
      doorSizeId: $doorSizeId
      dropoffFee: $dropoffFee
      initialFreeHours: $initialFreeHours
      rtsFee: $rtsFee
      rtsOverstayMaxFee: $rtsOverstayMaxFee
      rtsOverstayRate: $rtsOverstayRate
      rtsOverstayUnitHours: $rtsOverstayUnitHours
    ) {
      partnerDropoffFee {
        partnerDropoffFeeId
      }
    }
  }
`;
export const ADD_PARTNER_SHIPOUT_FEE = gql`
  mutation (
    $operatorId: ID!
    $lockerTypeId: ID!
    $partnerTypeId: ID!
    $doorSizeId: ID!
    $commissionPercent: Decimal!
    $initialShipoutFee: Decimal!
    $initialFreeHours: Int!
    $excessFeePerInc: Decimal!
    $incByHours: Int!
    $maxOverstayCharge: Decimal!
  ) {
    addPartnerShipoutFee(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      partnerTypeId: $partnerTypeId
      doorSizeId: $doorSizeId
      commissionPercent: $commissionPercent
      initialShipoutFee: $initialShipoutFee
      initialFreeHours: $initialFreeHours
      excessFeePerInc: $excessFeePerInc
      incByHours: $incByHours
      maxOverstayCharge: $maxOverstayCharge
    ) {
      partnerShipoutFee {
        partnerShipoutFeeId
      }
    }
  }
`;
export const UPDATE_DROPOFF_FEE = gql`
  mutation ($partnerDropoffFees: [UpdatePartnerDropoffFeeObject]!) {
    updatePartnerDropoffFee(partnerDropoffFees: $partnerDropoffFees) {
      partnerDropoffFee {
        partnerDropoffFeeId
      }
    }
  }
`;

export const UPDATE_PARTNER_SHIPOUT_FEE = gql`
  mutation ($partnerShipoutFees: [UpdatePartnerShipoutFeeObject]!) {
    updatePartnerShipoutFee(partnerShipoutFees: $partnerShipoutFees) {
      partnerShipoutFee {
        partnerShipoutFeeId
      }
    }
  }
`;

export const UPDATE_USER_PICKUP_FEE = gql`
  mutation ($userPickupFees: [UpdateUserPickupFeeObject]!) {
    updateUserPickupFee(userPickupFees: $userPickupFees) {
      userPickupFee {
        userPickupFeeId
      }
    }
  }
`;

export const ADD_USER_PICKUP_FEE = gql`
  mutation ($userPickupFees: [AddUserPickupFeeObject]!) {
    addUserPickupFeeBulk(userPickupFees: $userPickupFees) {
      userPickupFee {
        userPickupFeeId
      }
    }
  }
`;

export const USER_SHIPOUT_FEES = gql`
  query ($operatorId: ID!, $userTypeId: ID!, $lockerTypeId: ID!) {
    userShipoutFees(
      operatorId: $operatorId
      userTypeId: $userTypeId
      lockerTypeId: $lockerTypeId
    ) {
      userShipoutFeeId
      doorSize {
        doorSizeId
      }
      initialReturnFee
      addInitialFreeHours
      excessFeePerInc
      incByHours
      maxOverstayCharge
    }
  }
`;
export const ADD_USER_SHIPOUT_FEE_BULK = gql`
  mutation ($userShipoutFees: [AddUserShipoutFeeObject]!) {
    addUserShipoutFeeBulk(userShipoutFees: $userShipoutFees) {
      userShipoutFee {
        userShipoutFeeId
      }
    }
  }
`;

export const UPDATE_USER_SHIPOUT_FEE = gql`
  mutation ($userShipoutFees: [UpdateUserShipoutFeeObject]!) {
    updateUserShipoutFee(userShipoutFees: $userShipoutFees) {
      userShipoutFee {
        userShipoutFeeId
      }
    }
  }
`;

// ------------- ALL LOCKERS ------------
export const GET_ALL_LOCKER_NAMES_NEW = gql`
  {
    allLockers {
      lockerId
      lockerName
    }
  }
`;
